import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  identificationOptions,
  NOMINEE,
  NOMINEEERROR,
  Required,
  TYPE,
} from "../addNominee/constant";
import { IdentifDet } from "../addNominee/identificationSection";
interface Type {
  id: number;
  name: string;
  fieldName: string;
}
export const IdentificationForNominee = forwardRef((props: any, ref: any) => {
  const [type, setType] = useState<Type>();
  const [nominee, setNominee] = useState<any>();
  const [nomineeErr, setNomineeErr] = useState<any>(NOMINEEERROR);
  const [identity, setIdentity] = useState<any>();
  const [hasErr, setHasErr] = useState<any>();
  const [showOptional, setShowOptional] = useState<boolean>(false);

  const childRef = useRef<any>();

  useEffect(() => {
    const Type = TYPE.find((t) => t.id === props.type);
    setNominee(
      Type?.id === 1 ? props.nominee[props.id] : props.nominee[props.id].guard
    );

    setType(Type);
  }, []);
  useImperativeHandle(ref, () => ({
    validation() {
      let err: any = nomineeErr;
      let validation = true;
      const required = [];

      if (identity) {
        if (
          identity === identificationOptions[1].value ||
          identity === identificationOptions[6].value
        ) {
          required.push("attachment");
        } else {
          required.push(identity);
        }
      } else {
        // err.identity = "This Field is Required.";
        // validation = false;
      }

      required.map((x: any) => {
        const child: any = childRef?.current;
        if (child && child.hasError(nominee[x])) {
          validation = false;
          setHasErr(true);
        } else setHasErr(false);
        if (x === "attachment") {
          nominee[x] = nominee[x]?.data;
        }
        if (
          nominee[x] === "" ||
          nominee[x] === null ||
          nominee[x] === undefined
        ) {
          // err[x] = `This field is Required.`;
          validation = false;
        }
      });

      return validation;
    },
  }));
  useEffect(() => {
    if (hasErr) {
      props.enableSubmit(false);
    } else {
      if (
        Object.values(nomineeErr)
          .map((x) => x === "" || x === null || x === undefined)
          .every((x) => x === true)
      ) {
        props.enableSubmit(true);
      } else {
        props.enableSubmit(false);
      }
    }
  }, [nomineeErr, hasErr]);

  const onChange = (value: any) => {
    let nom = nominee;
    setNominee({ ...nom, ...value });
    const key = Object.keys(value)[0];

    setNomineeErr({ ...nomineeErr, [key]: "" });
    const totalNominee = JSON.parse(JSON.stringify(props.nominee));
    if (props.type === 1) {
      totalNominee[props.id] = {
        ...nom,
        ...value,
      };
    } else {
      totalNominee[props.id].guard = {
        ...nom,
        ...value,
      };
    }

    props.updateNominee(totalNominee);
  };

  return (
    <>
      <div className="optional">
        <div className="display-flex space-between-aligned">
          <div className="button">
            <button type="button" onClick={() => setShowOptional(true)}>
              <i className="edel-icon-dots-three-horizontal dotIcon"></i>
              <span>Optional</span>
            </button>
          </div>
          <div>
            <i
              className="edel-icon-close"
              onClick={() => setShowOptional(false)}
            ></i>
          </div>
        </div>

        {showOptional && (
          <div className="optional-fields">
            {nominee && type && nomineeErr && (
              <IdentifDet
                type={type}
                id={props.id}
                onChange={onChange}
                nominee={nominee}
                setNomineeErr={setNomineeErr}
                nomineeErr={nomineeErr}
                userPan={props.userPan}
                accountCode={props.accountCode}
                setLoader={props.setLoader}
                updateIdentity={setIdentity}
                ref={childRef}
              ></IdentifDet>
            )}
          </div>
        )}
      </div>
    </>
  );
});
